import { useEffect } from 'react';
import { useSite } from '../context/SiteContext';
import styles from './PrivacyPolicyModal.module.css';

export default function PrivacyPolicyModal({ onClose }) {
  const { data } = useSite();
  const pp = data.privacyPolicy;

  // Lock body scroll while open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  // Close on Escape
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className={styles.header}>
          <div>
            <div className={styles.label}>Legal</div>
            <h2 className={styles.title}>Privacy Policy</h2>
            {pp.lastUpdated && (
              <p className={styles.updated}>Last updated: {pp.lastUpdated}</p>
            )}
          </div>
          <button className={styles.closeBtn} onClick={onClose} aria-label="Close">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className={styles.body}>
          {pp.sections.map((section, i) => (
            <div key={section.id} className={styles.section}>
              <div className={styles.sectionNumber}>{String(i + 1).padStart(2, '0')}</div>
              <div className={styles.sectionContent}>
                <h3 className={styles.sectionTitle}>{section.title}</h3>
                <p className={styles.sectionBody}>{section.body}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <span>© {new Date().getFullYear()} Keepers Experience. All rights reserved.</span>
          <button className={styles.closeFooterBtn} onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
